import * as React from "react";

import {
    List, Datagrid,
    TextField, FunctionField, DateField, 
    ReferenceInput, AutocompleteInput,
    TopToolbar, FilterButton, ExportButton, sanitizeListRestProps,required, downloadCSV
} from 'react-admin';

import renderPhoneNumber from './Renderers/renderPhoneNumber';
import DownloadAutoresponseWordButton from "./DownloadAutoresponseWordButton";

import jsonExport from 'jsonexport/dist';

const PPGCSubmissionsListActions = (props) => {
    const {
        className,
        ...rest
    } = props;
    return ( <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
        <FilterButton />
        <ExportButton maxResults='100000' />
    </TopToolbar> );
};

const filters = [
    <ReferenceInput fullWidth label="Pattern Type" source="pattern_id" reference="patterns" alwaysOn filter={{ id: [22,23,24] }} validate={[required()]}>
            <AutocompleteInput optionText="label"/>
        </ReferenceInput>
];

const PPGCExporter = submissions => {
    const submissionsForExport = submissions.map(submission => {
        var submissionsForExport = {};
        submissionsForExport.created_at = submission.created_at;
        submissionsForExport.submission_id = submission.id;
        submissionsForExport.sic_number = submission.sic_number;

        if ( null !== submission.values )
        {
            var values = {};
            if ( "string" === typeof submission.values )
                values = JSON.parse( submission.values );

            if ( "object" === typeof( submission.values ) )
                values = submission.values;

            submissionsForExport.constituent_id = values.constituent_id;
            submissionsForExport.first_name = values.first_name;
            submissionsForExport.last_name = values.last_name;
            submissionsForExport.email = values.email;
            submissionsForExport.phone_cell = values.phone_cell;
            submissionsForExport.postal_code = values.postal_code;
            submissionsForExport.constituency = values.ppgc_sponsor;
            submissionsForExport.constituency_relation = values.constituency_relationship;
            submissionsForExport.action = values.ppgc_action;

            if ( submission.pattern_id == 22 ) // governance
                submissionsForExport.article = values.ppgc_article_governance_2025;

            if ( submission.pattern_id == 23 ) // policy
                submissionsForExport.article = values.ppgc_article_policy_2025;

            if ( submission.pattern_id == 24 ) // bylaw
                submissionsForExport.article = values.ppgc_article_bylaw_2025;

            submissionsForExport.opening_sentence = values.ppgc_opening;
            submissionsForExport.resolution = values.ppgc_submission.replace( /<[^>]*>/g, '' );
            submissionsForExport.rationale = values.ppgc_rationale.replace( /<[^>]*>/g, '' );
        }

        return submissionsForExport;
    });
    jsonExport(submissionsForExport, {
        headers: [
                'created_at',
                'submission_id',
                'sic_number',
                'constituent_id',
                'first_name',
                'last_name',
                'email',
                'phone_cell',
                'postal_code',
                'constituency',
                'constituency_relation',
                'action',
                'article',
                'opening_sentence',
                'resolution',
                'rationale'
            ]
    }, (err, csv) => {
        downloadCSV(csv, 'submissions');
    });
};

export const SubmissionsListPPGC = (props) => (
    <List {...props} actions={<PPGCSubmissionsListActions {...props} />}filters={filters} filterDefaultValues={{ pattern_id: 22 }} sort={{ field: 'created_at', order: 'DESC' }} bulkActionButtons={false} exporter={PPGCExporter}>
        <Datagrid>
            <TextField label="Submission ID" source="id" />
            <TextField label="SIC Number" source="sic_number" />
            <TextField label="Constituent ID" source="values.constituent_id" />
            <TextField label="Last Name" source="values.last_name" />
            <TextField label="First Name" source="values.first_name" />
            <TextField label="Email" source="values.email" />
            <FunctionField label="Phone" render={ record => renderPhoneNumber(record.values.phone_cell) } />
            <DateField label="Date" source="created_at" showTime options={{ dateStyle: 'long', timeStyle: 'short' }} />
            <DownloadAutoresponseWordButton {...props}/>
        </Datagrid>
    </List>
)

export default SubmissionsListPPGC;